<p-card>
  <div class="mb-4 text-xl">{{ 'workplace.basicInfoTitle' | translate }}</div>
  <div class="grid-6col input-grid-gaps">
    <app-text-input [form]="form" id="name" [prefix]="prefix"></app-text-input>
    <app-date-input [form]="form" id="dateFrom"></app-date-input>
    <app-date-input [form]="form" id="dateTo"></app-date-input>
    <app-phone-input [form]="form" id="phone" label="workplace.fields.phone"></app-phone-input>
    <app-email-input [form]="form" id="email" label="workplace.fields.email"></app-email-input>
    @if (service()?.type === ServiceTypeEnum.HEALTH_CARE) {
      @if (!hideDefaultIcp) {
        <app-text-input [form]="form" id="defaultIcp"
        prefix="workplace."></app-text-input>
      }
    }
  </div>
</p-card>

@if (workplaceId) {
  <p-divider></p-divider>
  <app-workplace-detail-addresses></app-workplace-detail-addresses>
  <p-divider></p-divider>
  <app-workplace-detail-responsible-persons></app-workplace-detail-responsible-persons>
  <p-divider></p-divider>
  @if (service()?.type === ServiceTypeEnum.HEALTH_CARE) {
    <app-workplace-detail-icps></app-workplace-detail-icps>
  }
}

<p-divider></p-divider>

<app-action-buttons [primaryButtonDisability]="form.untouched" (primaryClickEvent)="save()"
(secondaryClickEvent)="goBack()"></app-action-buttons>
